function isLocalDevSpaHost(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.localhost')
}

/** Tunnel dev : folkyn-dev.bloby.co → API folkyn-back.bloby.co */
export function inferTunnelApiBaseUrl(spaOrigin: string): string | null {
  try {
    const host = new URL(spaOrigin).hostname
    if (host === 'folkyn-dev.bloby.co') {
      return 'https://folkyn-back.bloby.co'
    }
  } catch {
    // ignore invalid origin
  }
  return null
}

function resolveApiBaseUrl(spaOrigin?: string): string {
  const configured = import.meta.env.VITE_NEXTJS_API_URL as string | undefined
  if (configured?.trim()) {
    return configured.replace(/\/+$/, '')
  }

  if (spaOrigin) {
    const inferred = inferTunnelApiBaseUrl(spaOrigin)
    if (inferred) {
      return inferred
    }
  }

  return ''
}

/**
 * URL API pour axios/fetch.
 * Local : origine SPA + proxy Vite /api (ignore VITE_NEXTJS_API_URL).
 * Tunnel/prod : VITE_NEXTJS_API_URL ou inférence bloby.
 */
export function getNextjsApiBaseUrl(): string {
  if (typeof window !== 'undefined') {
    const origin = window.location.origin.replace(/\/+$/, '')

    if (isLocalDevSpaHost(window.location.hostname)) {
      return origin
    }

    const resolved = resolveApiBaseUrl(origin)
    if (resolved) {
      return resolved
    }

    return origin
  }

  const resolved = resolveApiBaseUrl()
  if (resolved) {
    return resolved
  }

  return 'http://localhost:1234'
}

/** Alias explicite pour OAuth / handoff (même résolution que getNextjsApiBaseUrl). */
export function getNextjsOAuthApiBaseUrl(): string {
  return getNextjsApiBaseUrl()
}

/** URL callback Supabase unifiée (API serveur). */
export function buildPublicAuthCallbackUrl(options?: {
  signupIntent?: string
  invitationToken?: string
  preferredLocale?: string
  redirectUrl?: string | null
  role?: string
}): string {
  if (typeof window === 'undefined') {
    throw new Error('buildPublicAuthCallbackUrl requires browser context')
  }

  const apiBase = getNextjsOAuthApiBaseUrl()
  const frontendOrigin = window.location.origin.replace(/\/+$/, '')
  const url = new URL(`${apiBase}/api/app/v1/auth/callback`)

  url.searchParams.set('frontend_origin', frontendOrigin)
  url.searchParams.set('signup_intent', options?.signupIntent ?? 'email_verification')

  if (options?.invitationToken) {
    url.searchParams.set('invitation_token', options.invitationToken)
  }
  if (options?.preferredLocale) {
    url.searchParams.set('preferred_locale', options.preferredLocale)
  }
  if (options?.redirectUrl) {
    url.searchParams.set('redirect_url', options.redirectUrl)
  }
  if (options?.role) {
    url.searchParams.set('role', options.role)
  }

  return url.toString()
}
